import Icon from 'veui/components/Icon'

Icon.register({
  bullseye: {
    paths: [
      {
        d: 'M9.87 39.2a2 2 0 01-2.82 2.83 24.01 24.01 0 1133.8.1 2 2 0 11-2.81-2.85 20.01 20.01 0 10-28.17-.09zm5.82-5.88a2 2 0 11-2.75 2.9A15.67 15.67 0 018 24.8 15.9 15.9 0 0124 9c8.83 0 16 7.07 16 15.8 0 4.43-1.85 8.57-5.06 11.53a2 2 0 01-2.71-2.93A11.7 11.7 0 0036 24.8 11.9 11.9 0 0024 13c-6.63 0-12 5.3-12 11.8 0 3.26 1.35 6.3 3.69 8.52zm5.34-5.3a2 2 0 01-3.03 2.6 8.3 8.3 0 01-2-5.42 8.1 8.1 0 018-8.2c4.43 0 8 3.69 8 8.2a8.3 8.3 0 01-2.2 5.65 2 2 0 11-2.93-2.72A4.3 4.3 0 0028 25.2a4.1 4.1 0 00-4-4.2c-2.2 0-4 1.87-4 4.2a4.3 4.3 0 001.03 2.82z'
      }
    ],
    width: '48',
    height: '48'
  }
})
